module.exports = __webpack_public_path__ + "img/menusim.4cb15e2a.png";